var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sqlTextBox"},[_c('sf-input-group',{staticClass:"h-100",attrs:{"inputType":"textarea","inputValue":_vm.contentText,"labelSpan":0,"labelPosition":"left","onChange":value => _vm.onChange(value),"placeholder":"textarea"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }